import React, { Component } from 'react';

import { Run, RuleRunner } from '../Validation/RuleRunner'
import { required, eqLength } from '../Validation/Rules';
import Urls from '../../common/Urls';
import Config from '../../config';
import Styles from "../../styles/Styles";


const fieldValidations = [
  RuleRunner("number", "Le numéro envoyé par SMS", required, eqLength(6)),
];

export default class SMSVerification extends Component {

  constructor(props) {
    super(props);

    this.state = {
      phoneNumber: props.phoneNumber,
      generatedNumber: "",
      number: "",
      validationErrors: {},
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.sendSMS();
  }

  getObject() {
    return this.state;
  }

  handleChange(event) {
    const name = event.target.name;

    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    var value = event.target.value;
    if (value === "on") {
      value = event.target.checked
    }
  
    // Update the businessHour object
    //responsibles[index][key] = value;
    this.setState({
      [name]: value
    });
  }

  /**
   * Generate number and sms structure for api
   * and we send them
   */
  sendSMS() {
    let generatedNumber = "" 

    for (let i = 0; i < 6; i++) {
      generatedNumber += this.generateNumber();
    }

    this.setState({
      generatedNumber: generatedNumber,
      number: Config.isTest?generatedNumber:""
    }, !Config.isTest?this.callSMSApi:null )
  }

  /**
   * Send a sms to specify which code to enter
   */
  callSMSApi() {
    fetch(Urls.sendSMS(), {
        method: 'POST',
        mode: "no-cors",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          isTest: Config.isTest,
          message: "Voici votre code d'identification pour signer numeriquement votre contrat "+Config.program.programName+" : " + this.state.generatedNumber,
          sender: Config.program.sender,
          phoneNumber: this.state.phoneNumber
        })
      })
      .then((response) => console.log(response))
      .catch((error) => console.log(error));
  }

  generateNumber() {
    return Math.floor((Math.random() * 9) + 1);
  }

  /**
   * @return boolean false if there are some errors
   */
  checkForm(evt) {

    evt.preventDefault();
    evt.stopPropagation();

    let errors = Run(this.state, fieldValidations);

    if (Object.keys(errors).length === 0) {
      if (this.state.generatedNumber !== this.state.number) {
        errors["number"] = "Le numéro n'est pas le même que celui envoyé par SMS"
      }
    }

    this.setState({
      validationErrors: errors
    });

    if (Object.keys(errors).length === 0){
      this.props.onValidate();
      return true;
    }
    return false;
  }

  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  render() {
    return (
      <fieldset className="form-fieldset">
        <legend className="form-fieldset-legend">Validation par SMS</legend>
        <div>
          Un SMS vous a été envoyé au numéro suivant : {this.state.phoneNumber} <br/>
        </div>
        <div>
          <label className="label" htmlFor="number">Veuillez saisir le code de validation qui vous a été envoyé par SMS</label>
          <input id="number" name="number" type="text" placeholder="Numéro envoyé par SMS" className={"textbox textbox-full textbox-program-"+Config.program.style}
            onChange={this.handleChange}
            defaultValue={this.state.number} 
            required
          />
          <button style={Styles.Style.bgColorMain} className="margin-top-m btn btn-lg btn-primary-primary" onClick={(evt)=>this.checkForm(evt)}>Valider</button>
          <span className="form-error">{this.errorFor("number")}</span>
        </div>
      </fieldset>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/Forms/SMSVerification.js